/* eslint-disable jsx-a11y/iframe-has-title,react/no-unescaped-entities,no-unused-vars,no-plusplus */
import React, {Component} from 'react';
import postscribe from 'postscribe';
import {Helmet} from "react-helmet";
import MainBG from './MainBG';
import MobileBG from './MobileBG';
import Insight from './Insight';
import ReportingLine from './ReportingLine';
import ReportingLineMobile from './ReportingLineMobile';
import TradingArrows from './TradingArrows';
import './InfographicLanding.scss';
import {trackEventByUrl} from "../../helpers/events";

class InfographicLanding extends Component {

    state = {
        scriptsLoaded: false
    };

    componentDidMount() {
        this.setupSwipeEvents();
        this.handleLoading();
    }

    /**
     * Sets up event listeners on all mobile sliders
     */
    setupSwipeEvents = () => {

        /** Trading Items */
        const tradingSlider = document.getElementsByClassName("trading__items-wrap")[0];
        const tradingButtons = document.getElementsByClassName("trading_button");
        tradingSlider.addEventListener("touchend",(event) => {
            // Get the index of the current item in the slider
            let index = 0;
            for(let i = 0; i < tradingButtons.length; i++) {
                if(tradingButtons[i].className.includes('active')) {
                    index = i;
                }
            }
            this.animateSwipe(event.changedTouches[0].clientX, index, tradingButtons)
        }, false);

        /** Reporting Items */
        const reportingSlider = document.getElementsByClassName("reporting__cloud")[0];
        const reportingButtons = document.getElementsByClassName("report_button");
        reportingSlider.addEventListener("touchend",(event) => {
            // Get the index of the current item in the slider
            let index = 0;
            for(let i = 0; i < reportingButtons.length; i++) {
                if(reportingButtons[i].className.includes('active')) {
                    index = i;
                }
            }
            this.animateSwipe(event.changedTouches[0].clientX, index, reportingButtons)
        }, false);

        /** Insight Items */
        const insightSlider = document.getElementsByClassName("insight__items")[0];
        const insightButtons = document.getElementsByClassName("insight_button");
        insightSlider.addEventListener("touchend",(event) => {
            // Get the index of the current item in the slider
            let index = 0;
            for(let i = 0; i < insightButtons.length; i++) {
                if(insightButtons[i].className.includes('active')) {
                    index = i;
                }
            }
            this.animateSwipe(event.changedTouches[0].clientX, index, insightButtons)
        }, false);
    }

    /**
     * Clicks the pagination button to imitate swiping content in a mobile slider
     * 
     * @param xIndecx - X coordinate of where the swipe ended on screen
     * @param buttonIndex - index of the current item rendered in the slider
     * @param paginationButtons - array of pagination button for the current slider
     */
    animateSwipe = (xIndex, buttonIndex, paginationButtons) => {
        if(xIndex < window.innerWidth / 2) {
            // Click the related pagination button to imitate swipe
            if(buttonIndex + 1 < paginationButtons.length) {
                paginationButtons[buttonIndex + 1].click();
            }
        } else if(buttonIndex - 1 >= 0) {
            // Click the related pagination button to imitate swipe
            paginationButtons[buttonIndex - 1].click();
        }
    }

    handleLoading = () => {
        const element = document.getElementById('infographicLandingPage');

        if (element && !this.state.scriptsLoaded) {

            // Load Styles
            // postscribe('#infographicLandingPage', '<link rel="stylesheet" href="/public/infographiclanding/css/normalize.css">');
            // postscribe('#infographicLandingPage', '<link rel="stylesheet" href="/public/infographiclanding/css/main.css">');
            // postscribe('#infographicLandingPage', '<link rel="stylesheet" href="/public/infographiclanding/css/style.css">');

            // Load Scripts
            postscribe('#infographicLandingPage', '<script src="https://code.jquery.com/jquery-3.4.1.min.js" integrity="sha256-CSXorXvZcTkaix6Yvo6HppcZGetbYMGWSFlBw8HfCJo=" crossorigin="anonymous"></script>');
            postscribe('#infographicLandingPage', '<script>window.jQuery || document.write(\'<script src="/public/infographiclanding/js/vendor/jquery-3.4.1.min.js"><\\/script>\')</script>');
            postscribe('#infographicLandingPage', '<script src="https://cdnjs.cloudflare.com/ajax/libs/ScrollMagic/2.0.3/ScrollMagic.js"></script>');
            postscribe('#infographicLandingPage', '<script src="https://cdnjs.cloudflare.com/ajax/libs/ScrollMagic/2.0.7/plugins/debug.addIndicators.js"></script>');
            postscribe('#infographicLandingPage', '<script src="https://cdnjs.cloudflare.com/ajax/libs/gsap/2.0.1/TweenLite.min.js"></script>');
            postscribe('#infographicLandingPage', '<script src="https://cdnjs.cloudflare.com/ajax/libs/gsap/2.0.1/TweenMax.min.js"></script>');
            postscribe('#infographicLandingPage', '<script src="https://cdnjs.cloudflare.com/ajax/libs/gsap/2.0.1/TimelineMax.min.js"></script>');
            postscribe('#infographicLandingPage', '<script src="https://cdnjs.cloudflare.com/ajax/libs/ScrollMagic/2.0.7/plugins/animation.gsap.js"></script>');
            postscribe('#infographicLandingPage', '<script src="/public/infographiclanding/js/snap.svg.js"></script>');
            postscribe('#infographicLandingPage', '<script src="/public/infographiclanding/js/app.js"></script>');

            // GA
            postscribe('#infographicLandingPage', '<script>window.ga = function () { ga.q.push(arguments) }; ga.q = []; ga.l = +new Date; ga(\'create\', \'UA-XXXXX-Y\', \'auto\'); ga(\'set\',\'transport\',\'beacon\'); ga(\'send\', \'pageview\')</script>');
            postscribe('#infographicLandingPage', '<script src="https://www.google-analytics.com/analytics.js" async></script>');

            // LinkedIn (removed by BN since went to GTM)
//            postscribe('#infographicLandingPage', '<script type="text/javascript">\n                    _linkedin_partner_id = "1340441";\n                    window._linkedin_data_partner_ids = window._linkedin_data_partner_ids || [];\n                    window._linkedin_data_partner_ids.push(_linkedin_partner_id);\n                    </script><script type="text/javascript">\n                    (function(){var s = document.getElementsByTagName("script")[0];\n                    var b = document.createElement("script");\n                    b.type = "text/javascript";b.async = true;\n                    b.src = "https://snap.licdn.com/li.lms-analytics/insight.min.js";\n                    s.parentNode.insertBefore(b, s);})();\n                </script>');
//            postscribe('#infographicLandingPage', '<noscript><img height="1" width="1" style="display:none;" alt="" src="https://px.ads.linkedin.com/collect/?pid=1340441&fmt=gif" /></noscript>');

            this.setState({scriptsLoaded: true})
        }
    };

    render() {
        return (
            <div id="infographicLandingPage">
                <Helmet>
                    <title>SFTR reporting solution | MarketAxess</title>
                    <meta name="description" content="Explore our end-to-end reporting solution for compliance with the Securities Financing Transactions Regulation (SFTR), including generating and sharing UTIs."/>
                </Helmet>
                <div className="mx-landing-outer">
                    <div className="mx-landing">
                        <div>
                            <main id="main">

                                <MainBG/>
                                <MobileBG/>

                                <section className="intro">
                                    <div className="container">
                                        <div className="intro__wrap">
                                            <h1 className="intro__title">
                                                We're ready for sftr reporting, <span>are you?</span>
                                            </h1>
                                            <a href="#form" className="btn-demo intro__btn" id="intro-btn">Learn More</a>
                                        </div>
                                        <div className="intro__desc">
                                            <p>
                                                <span>The countdown to the Securities Financing
                                                Transactions Regulation (SFTR) is fast approaching and the
                                                requirements are complex</span> — covering everything from detailed reporting to
                                                collateral management, to the complete trade lifecycle.
                                            </p>
                                            <p>
                                                <span>MarketAxess has built a solution</span> to help you
                                                automate, standardize and streamline the compliance process at every stage.
                                            </p>
                                            <p>
                                                <span>Our test environment is live.</span> You can onboard and begin testing today - well in advance of the 2020 deadline.
                                            </p>
                                            <p>
                                                <span>Now is the time to get ready for SFTR compliance.</span>
                                            </p>
                                        </div>
                                        <div className="intro__more">
                                            <p>Learn more about<br/>our solution<br/></p>
                                            <a href="#trading" className="button">
                                                <img src="/public/infographiclanding/img/chevron.svg" style={{width: '23px'}} alt="chevron"/>
                                            </a>
                                        </div>
                                    </div>
                                </section>

                                <section className="trading" id="trading">
                                    <div className="trading__animated-graphic">
                                        <img className="trading__img" src="/public/infographiclanding/gifs/Trading.gif" alt="Trading" />
                                        <TradingArrows/>
                                    </div>
                                    <div className="trading__container">
                                        <div className="trading__intro">
                                            <div className="trading__intro-wrap hidden-bottom">
                                                <h2 className="trading__title section__title">Trading</h2>
                                                <p className="trading__desc section__desc">Execute your trades on or off-venue,
                                                    assign your collateral at beneficial owner level, and review other reportable
                                                    Securities Financing Transactions from your asset management, treasury or other
                                                    impacted divisions.
                                                </p>
                                            </div>
                                        </div>
                                        <div className="trading__items">
                                            <div className="trading__items-wrap">
                                                <div className="trading__item section__item server hidden-left pagination__item trading__item_1">
                                                    <img className="server__img" src="/public/infographiclanding/gifs/Server.gif" alt=""/>
                                                    <h3 className="trading__item__title section__item__title" style={{marginTop: '10px'}}>Accurate and complete collection of transaction
                                                        data from the leading MTF, including Unique Transaction Identifiers</h3>
                                                    <p className="section__item__desc">
                                                        Our joint SFTR solution is the only one connected to the leading multilateral trading facility (MTF)
                                                        in securites lending, EquiLend’s Next Generation Trading (NGT). It allows the capture of 100% of a
                                                        client’s book – including NGT and non-venue trades – and submission to Trax Insight for enrichment,
                                                        UTI sharing and reporting.
                                                    </p>
                                                </div>
                                                <div className="trading__item section__item fingerprint hidden-left pagination__item trading__item_2">
                                                    <img className="fingerprint__img" src="/public/infographiclanding/gifs/Fingerprint.gif" alt=""/>
                                                    <h3 className="trading__item__title section__item__title">Unique Transaction Identifier (UTI) generation</h3>
                                                    <p className="section__item__desc">UTIs generated on-venue (EquiLend’s NGT) at the point
                                                        of trade are sent to our Trax reporting engine. When generated off-venue,
                                                        these can also be incorporated and reported.
                                                    </p>
                                                </div>
                                                <div className="trading__controls pagination">
                                                    <button className="reporting__pagination pagination__btn trading_button pagination__btn--active" data-show="1" data-identifier="trading__item"/>
                                                    <button className="reporting__pagination pagination__btn trading_button" data-show="2" data-identifier="trading__item"/>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </section>

                                <section className="matching">
                                    <div className="container">
                                        <div className="matching__intro">
                                            <div className="matching__wrap hidden-bottom">
                                                <h2 className="matching__title section__title">Matching</h2>
                                                <p className="matching__desc section__desc">
                                                    Your trades can be matched via Trax Repo, EquiLend’s Unified Comparison or any other
                                                    contract compare provider. We accept data from EquiLend to our Trax Insight platform
                                                    every 15 minutes, to provide you with a pre-repository match on SFT fields.
                                                </p>
                                            </div>
                                            <div className="matching__items">
                                                <div className="matching__sub-item section__item">
                                                    <img className="matching__img" src="/public/infographiclanding/gifs/Clipboard_01.gif" alt=""/>
                                                    <h3 className="matching__item__title section__item__title">Operational efficiency</h3>
                                                </div>
                                                <div className="matching__sub-item section__item">
                                                    <img className="matching__img" src="/public/infographiclanding/gifs/Bar-chart_01.gif" alt=""/>
                                                    <h3 className="matching__item__title section__item__title">Data<br/> accuracy</h3>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="uti matching__item side-item section__item">
                                            <img className="matching-side__img" src="/public/infographiclanding/gifs/TRAX-UTI-Portal.gif" alt=""/>
                                            <h3 className="matching__item__title section__item__title">UTI portal</h3>
                                            <p className="section__item__desc">
                                                We have developed a unique portal for industry-wide centralized
                                                storage of UTIs, regardless of source. Counterparties can share UTIs no
                                                matter what solution they choose.
                                            </p>
                                        </div>
                                    </div>
                                </section>

                                <section className="reporting">
                                    <div className="container">
                                        <div className="reporting__intro">
                                            <div className="reporting__wrap hidden-bottom">
                                                <h2 className="reporting__title section__title">Reporting</h2>
                                                <p className="reporting__desc section__desc">
                                                    Ensure your transaction reports are complete and
                                                    submitted to your chosen TR as early as possible, leveraging our
                                                    30+ years of regulatory reporting experience.
                                                </p>
                                            </div>
                                        </div>
                                        <img className="reporting__img" src="/public/infographiclanding/gifs/Reporting_02.gif" alt=""/>
                                        <div className="section__item reporting__cloud">
                                            <h3 className="section__item__title">Our joint SFTR solution ensures
                                                trades are filtered, enriched, validated and reported.</h3>
                                            <ReportingLine/>
                                            <ReportingLineMobile/>
                                            <ul className="reporting__list">
                                                <li className="hidden-left reporting__list__item_1 reporting__list__item">
                                                    <p className="section__item__desc">
                                                        Our eligibility logic identifies transactions required under SFTR,
                                                        with 155 total reportable fields, of which up to 96 are reconcilable.
                                                    </p>
                                                </li>
                                                <li className="hidden-left reporting__list__item_2 reporting__list__item">
                                                    <p className="section__item__desc">
                                                        We store and maintain static data, including counterparty and entity
                                                        data, to enrich up to 44 fields utilizing our Trax reference database.
                                                    </p>
                                                </li>
                                                <li className="hidden-left reporting__list__item_3 reporting__list__item">
                                                    <p className="section__item__desc">
                                                        You benefit from our fast, accurate, technical- and scenario-based
                                                        rules engine providing 270 business validation checks.
                                                    </p>
                                                </li>
                                            </ul>
                                            <div className="pagination">
                                                <button className="reporting__pagination pagination__btn report_button pagination__btn--active" data-show="1" data-identifier="reporting__list__item" data-arrow="reporting__arrow__item"/>
                                                <button className="reporting__pagination pagination__btn report_button" data-show="2" data-identifier="reporting__list__item" data-arrow="reporting__arrow__item"/>
                                                <button className="reporting__pagination pagination__btn report_button" data-show="3" data-identifier="reporting__list__item" data-arrow="reporting__arrow__item"/>
                                            </div>
                                        </div>
                                        <div className="reporting__items">
                                            <div className="submit reporting__item section__item hidden-left">
                                                <img className="reporting__item__img" src="/public/infographiclanding/gifs/Trade-repository.gif" alt=""/>
                                                <h3 className="reporting__item__title section__item__title">Submit to your chosen TR</h3>
                                                <p className="section__item__desc">
                                                    You have total control to share complete transaction
                                                    reports to your selected trade repository.
                                                </p>
                                            </div>

                                            <div className="delegated reporting__item section__item hidden-left">
                                                <img className="reporting__item__img" src="/public/infographiclanding/gifs/Delegated-reporting.gif" alt=""/>
                                                <h3 className="reporting__item__title section__item__title">Delegated reporting made simple</h3>
                                                <p className="section__item__desc">
                                                    We support delegated reporting to reduce the operational burden on you.
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </section>

                                <section className="insight">
                                    <div className="container">
                                        <div className="insight__intro">
                                            <div className="insight__img">
                                                <img src="/public/infographiclanding/gifs/MA_Trax-Insight.gif" alt="" />
                                                <Insight/>
                                            </div>
                                            <div className="insight__intro-wrap hidden-bottom">
                                                <h2 className="insight__title section__title">Insight</h2>
                                                <p className="insight__desc section__desc">
                                                    Our user experience, Trax Insight, provides transparency and control
                                                    over your reporting, helping you identify and manage exceptions and data
                                                    quality issues.
                                                </p>
                                            </div>
                                        </div>
                                        <div className="insight__items">
                                            <div className="insight__item section__item hidden-left insight__item_1">
                                                <img className="insight__item__img" src="/public/infographiclanding/img/Customizable.svg" alt=""/>
                                                <h3 className="insight__item__title section__item__title">Customizable <br/>reporting analytics</h3>
                                                <p className="section__item__desc">
                                                    Use our advanced tools, with real-time reporting dashboards, bespoke
                                                    reports and industry benchmarking.
                                                </p>
                                            </div>
                                            <div className="insight__item section__item hidden-left insight__item_2">
                                                <img className="insight__item__img" src="/public/infographiclanding/img/Transparency.svg" alt=""/>
                                                <h3 className="insight__item__title section__item__title">Transparency at<br/> every stage</h3>
                                                <p className="section__item__desc">
                                                    Complete visibility with audit trails of all reporting decisions.
                                                </p>
                                            </div>
                                            <div className="insight__item section__item hidden-left insight__item_3">
                                                <img className="insight__item__img" src="/public/infographiclanding/img/Monitoring.svg" alt=""/>
                                                <h3 className="insight__item__title section__item__title">Monitoring</h3>
                                                <p className="section__item__desc">
                                                    Maintain total oversight of your reporting and the
                                                    status of trade submissions, including feedback on responses from
                                                    the trade repository when received.
                                                </p>
                                            </div>
                                            <div className="pagination">
                                                <button className="reporting__pagination pagination__btn insight_button pagination__btn--active" data-show="1" data-identifier="insight__item"/>
                                                <button className="reporting__pagination pagination__btn insight_button" data-show="2" data-identifier="insight__item"/>
                                                <button className="reporting__pagination pagination__btn insight_button" data-show="3" data-identifier="insight__item"/>
                                            </div>
                                        </div>
                                    </div>
                                </section>

                                <section className="sftr">
                                    <div className="container">
                                        <h2 className="sftr__title">Are you ready for SFTR?<br/><span>You can be, starting now</span></h2>
                                        <ul className="sftr__list">
                                            <li className="sftr__item section__item">
                                                <img className="sftr__item__img hidden-right" style={{width: '20px'}} src="/public/infographiclanding/img/blue-arrow.svg" alt=""/>
                                                <p>Complete front-to-back, one-stop SFTR solution from leading regulatory reporting experts.</p>
                                            </li>
                                            <li className="sftr__item section__item">
                                                <img className="sftr__item__img hidden-right" style={{width: '20px'}} src="/public/infographiclanding/img/blue-arrow.svg" alt=""/>
                                                <p>Access to the leading securities lending MTF and an industry-wide UTI sharing portal.</p>
                                            </li>
                                            <li className="sftr__item section__item">
                                                <img className="sftr__item__img hidden-right" style={{width: '20px'}} src="/public/infographiclanding/img/blue-arrow.svg" alt=""/>
                                                <p>
                                                    30+ years of experience in regulatory reporting,
                                                    covering multiple regulations across multiple jurisdictions.
                                                </p>
                                            </li>
                                        </ul>
                                        <div className="sftr__demo">
                                            <h3 className="sftr__demo__desc">Test environment available now.<br/>
                                                Onboard and begin testing, today.</h3>
                                            <a href="#form" className="sftr__demo__btn btn-demo">Learn More</a>
                                        </div>
                                    </div>
                                </section>

                            </main>

                            <footer className="footer__wrapper" id="form">
                                <section className="form__bg"/>
                                <section className="form" data-attr="in-active">
                                    <form action="https://webto.salesforce.com/servlet/servlet.WebToLead?encoding=UTF-8" method="POST">
                                        <input type="hidden" name="oid" value="00D200000006r47"/>
                                        <input type="hidden" name="retURL" value="https://www.marketaxess.com/contact-us/thank-you"/>
                                        <div className="form__row">
                                            <div className="form__col">
                                                <div className="form__wrap">
                                                    <label htmlFor="first_name" className="form__label">First Name</label>
                                                    <input id="first_name" className="form__input" maxLength="40" name="first_name" size="20" type="text" /><br/>
                                                </div>
                                            </div>
                                            <div className="form__col">
                                                <div className="form__wrap">
                                                    <label htmlFor="last_name" className="form__label">Last Name</label>
                                                    <input id="last_name" className="form__input" maxLength="80" name="last_name" size="20" type="text" /><br/>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="form__row">
                                            <div className="form__col">
                                                <div className="form__wrap">
                                                    <label htmlFor="company" className="form__label">Company</label>
                                                    <input  id="company" className="form__input" maxLength="40" name="company" size="20" type="text" /><br/>
                                                </div>
                                            </div>
                                            <div className="form__col">
                                                <div className="form__wrap">
                                                    <label htmlFor="00N0J000009qnBl" className="form__label">Job Title:</label>
                                                    <select id="00N0J000009qnBl" className="form__input" name="00N0J000009qnBl" title="Job Title">
                                                        <option value="">--None--</option>
                                                        <option value="Administrative Assistant">Administrative Assistant</option>
                                                        <option value="Analyst">Analyst</option>
                                                        <option value="Assistant Vice President">Assistant Vice President</option>
                                                        <option value="Associate">Associate</option>
                                                        <option value="Director">Director</option>
                                                        <option value="Executive Director">Executive Director</option>
                                                        <option value="Portfolio Manager">Portfolio Manager</option>
                                                        <option value="President">President</option>
                                                        <option value="Principal">Principal</option>
                                                        <option value="Managing Director">Managing Director</option>
                                                        <option value="Salesperson">Salesperson</option>
                                                        <option value="Senior Vice President">Senior Vice President</option>
                                                        <option value="Trader">Trader</option>
                                                        <option value="Vice President">Vice President</option>
                                                    </select><br/>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="form__row">
                                            <div className="form__col">
                                                <div className="form__wrap">
                                                    <label htmlFor="email" className="form__label">Email</label>
                                                    <input id="email" className="form__input" maxLength="80" name="email" size="20" type="text"/><br/>
                                                </div>
                                            </div>
                                            <input id="00N0J00000AMqST" name="00N0J00000AMqST" type="hidden" value="1"/><br/>
                                            <div className="form__col">
                                                <div className="form__wrap">
                                                    <input type="submit" className="btn btn-send" name="submit"/>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="form__row disclaimer">
                                            <div className="form__wrap">
                                                <p>
                                                    The personal data you provide through submitting this form
                                                    will be used to help us engage you on the MarketAxess products
                                                    detailed above. Please note: If we have previously received your personal
                                                    data, we may be processing it in that context. For more detail on how
                                                    we process your personal data and to better understand your rights,
                                                    click the link below for our full privacy policy.
                                                </p>
                                                <a href="https://www.marketaxess.com/legal/privacy-policy" onClick={() => trackEventByUrl('/legal/privacy-policy', 'Privacy policy')}>
                                                    <p>Privacy policy</p>
                                                    <img src="/public/infographiclanding/img/white-arrow.svg" style={{width: '20px'}} alt=""/>
                                                </a>
                                            </div>
                                        </div>
                                    </form>
                                </section>
                                <section className="footer-primary">
                                    <div className="container">
                                        <div className="footer-primary__wrap">
                                            <div className="footer-primary-col">
                                                <p>
                                                    A single SFTR solution from MarketAxess, a leading provider of trading,
                                                    market data, post-trade and regulatory reporting services, used today
                                                    by over 200 of the world’s leading banks and asset managers.
                                                </p>
                                            </div>
                                            <div className="footer-primary-col">
                                                <div className="footer-primary__clients">
                                                    <span>130+<br/> MiFID<br/> clients</span>
                                                    <p>MarketAxess</p>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="footer-primary__links">
                                            <ul className="footer-primary__list">
                                                <li className="footer-primary__item">
                                                    <a href="https://www.marketaxess.com/" className="footer-primary__link" onClick={() => trackEventByUrl('/', 'Find out more about MarketAxess')}>
                                                        <p>Find out about MarketAxess</p>
                                                        <img src="/public/infographiclanding/img/white-arrow.svg" style={{width: '20px'}} alt=""/>
                                                    </a>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </section>
                            </footer>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default InfographicLanding;



// WEBPACK FOOTER //
// ./frontend/pages/InfographicLanding/InfographicLanding.jsx